/* eslint-disable no-useless-escape */
import styles from "../../../_common/CrudFormStyles.module.scss";
import { useEffect } from "react";
import { Form, Input, Row, Col, Badge, message, DatePicker, Select, Checkbox } from "antd";

import { translateKey as t } from "../../../../../locales/translation";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientsController } from "../../ClientsController";
import { observer } from "mobx-react";

const GeneralTab = observer(({ controller, form }: { controller: ClientsController; form: any }) => {
  useEffect(() => {}, []);

  const { selectedClient, isReadOnly, isSelectedReadOnly, formMode, formFieldsSize, showFieldsIcon } = controller;

  //--------------------------------------------------------------------------------------------------------------

  const handleInputChange = (e: any) => {
    let value: string = e.target.value;
    let key: string = e.target.name;

    // Prevents the selectedClient from using certain special characters and empty spaces
    if (key === "username" && !RegExp("^[a-zA-Z0-9_.@()&-]*$").test(value)) {
      // Instantly cuts the invalid character
      e.target.value = e.target.value.substring(0, e.target.value.length - 1);

      message.warning({
        content: t("lblUsernameMustNotContainThisSpecialCharacterOrSpaces", "Username must not contain this Special Character or Spaces"),
        key,
        duration: 4,
      });

      return;
    }
    // Prevents the selectedClient from using certain special characters, but allows empty spaces
    if ((key === "firstName" || key === "lastName") && !RegExp("^[ a-zA-Z0-9_.@()&-]*$").test(value)) {
      // Instantly cuts the invalid character
      e.target.value = e.target.value.substring(0, e.target.value.length - 1);

      if (key === "firstName") {
        message.warning({
          content: t("lblFirstNameMustNotContainThisSpecialCharacter", "First Name must not contain this Special Character"),
          key,
          duration: 4,
        });
      } else {
        message.warning({
          content: t("lblLastNameMustNotContainThisSpecialCharacter", "Last Name must not contain this Special Character"),
          key,
          duration: 4,
        });
      }

      return;
    }

    if (key === "password" && controller.formMode === "edit") {
      controller.passwordChanged = true;
    }

    controller.setSelectedClient(value, key);
  };

  //--------------------------------------------------------------------------------------------------------------
  console.log(selectedClient);
  return (
    <>
      <Row className={styles.newRow} gutter={20} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!selectedClient.clientRef}>
                <span className={styles.formTitle}>{t("lblClientRef", "Client Ref")}</span>
              </Badge>
            }
            name="clientRef"
            rules={[{ required: true, whitespace: true, message: t("lblClientRefIsRequired", "Client Ref is required") }]}
          >
            <Input
              onChange={handleInputChange}
              name="clientRef"
              disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              autoFocus={formMode === "create"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!selectedClient.name}>
                <span className={styles.formTitle}>{t("lblName", "Name")}</span>
              </Badge>
            }
            name="name"
            rules={[{ required: true, whitespace: true, message: t("lblNameIsRequired", "Name is required") }]}
          >
            <Input
              onChange={handleInputChange}
              name="name"
              disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              autoFocus={formMode === "create"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!selectedClient.dbName}>
                <span className={styles.formTitle}>{t("lblDatabase", "Database")}</span>
              </Badge>
            }
            name="dbName"
            rules={[{ required: true, whitespace: true, message: t("lblDatabaseIsRequired", "Database is required") }]}
          >
            <Input
              name="dbName"
              onChange={handleInputChange}
              disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} label={<span className={styles.formTitle}>{t("lblUpdatedAt", "Updated At")}</span>} name="formattedUpdatedAt">
            <DatePicker disabled showTime style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>

      {selectedClient.dbName.includes("of-pro") && (
        <Row className={styles.newRow} gutter={20} style={formFieldsSize === "small" && { marginTop: 0 }}>
          <Col span={12}>
            <Form.Item
              colon={false}
              label={
                <Badge dot={!selectedClient.vertical}>
                  <span className={styles.formTitle}>{t("lblVertical", "Vertical")}</span>
                </Badge>
              }
              name="vertical"
              rules={[{ required: true, whitespace: true, message: t("lblVerticalIsRequired", "Vertical is required") }]}
            >
              <Select showSearch={false} style={{ width: "100%", textAlign: "left" }} placeholder="Select a vertical" size={formFieldsSize} disabled={isReadOnly || isSelectedReadOnly}>
                {controller?.verticals?.map((vertical) => {
                  return (
                    <Select.Option key={vertical.ref} value={vertical.ref}>
                      {vertical.description}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item style={{ marginTop: 25 }} colon={false} name="proOptions.demo" valuePropName="checked">
              <Checkbox disabled={isReadOnly || isSelectedReadOnly}>
                <span className={styles.formTitle}>{t("lblDemo", "Demo")}</span>
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
});

export default GeneralTab;
